import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './style.css'
import { i18n } from './i18n'
import { useThemeStore } from './stores/theme'
import { useLocaleStore } from './stores/locale'
// Auth is auto-initialized when useAuth.ts is imported (via router.ts)

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(i18n)
app.use(router)

// Initialize theme before mounting to prevent flash
const themeStore = useThemeStore()
themeStore.init()

// Initialize locale before mounting (loads translations)
const localeStore = useLocaleStore()
localeStore.init()

app.mount('#app')
